export function servicePlanId(sp) {
  return `${sp.productId},${sp.categoryId}`;
}